import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ournycpartners',
  templateUrl: './ournycpartners.component.html',
  styleUrls: ['./ournycpartners.component.css']
})
export class OurnycpartnersComponent implements OnInit {
  @Input() nycOurPartners:any
  baseUrl = environment.staticUrlForImgNew
  constructor() { }

  ngOnInit(): void {
  }
  getImageUrl(contentUrl: string): string {
    return this.baseUrl + contentUrl;
  }
}
